import { Component, OnInit } from '@angular/core';
import { ApiPartnerService } from '../../api/api-partner.service';
import { ExcelServicesService } from '@app/_services/excel-service.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import {URLSearchParams} from '@angular/http';
import { FormGroup, FormControl, FormBuilder, NgForm, Validators } from '@angular/forms';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-adminreva-summarycicilan',
  templateUrl: './adminreva-summarycicilan.component.html',
  styleUrls: ['./adminreva.component.css']
})
export class AdminrevaSummarycicilanComponent implements OnInit {

  ListCustomer: any = {};	
  ListCustfilter: any = {};	
  ListCustexport: any = {};	
  paging: any = {};	
  msearch : string;
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';
  alert_act='';
  alert_actmsg='';
  isprint='';
  sumSubs : any;
  summaryCicilan : any = [];

  _STBdata: any = {
    'sn': ''
  };	
  
  table_load = false
  table_data = false
  table_filter = false
  isShow = false
  pagingshow = false
  printshow = false

  meta = [];
  self = [];
  excel = [];

  formFilter = this.fb.group({
    startdate : [''],
    enddate: [''],
    isprint: [''],
  });
  
  
  constructor(
    public partnerService: ApiPartnerService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private excelService:ExcelServicesService
  ) 
  {
    // this.partnerService.Listallcustfilter(this.formFilter.value).subscribe(output => {
    //   console.log(output)
    //   this.ListCustfilter = output
    //     this.ListCustfilter.data.forEach(row => {
    //       this.excel.push(row);
    //     });
    // });
  }

  ngOnInit() {
    this.loadStart();
    this.loadCicilan();
  }

  refreshPage() {
    this.isShow = false
    this.formFilter.reset()
    this.ngOnInit();
  }

  falset()
  {
    this.table_data = false
    this.table_filter = false
    this.pagingshow = false
    this.printshow = false
    this.table_load = true
  }

  _services(item: any)
  {
    let service = '';
    if ( item.services == null || item.services == 0 ){
      return service;
    }else{
      item.services.forEach(function (value: any) {
        service += value.servicename + '\n';
      });

      return service.replace(/(\\r\\n)|([\r\n])/gmi, ', ');
    }
  }
  
  isPairing(item: any)
  {
    return (item.services != null);
  }

  loadStart() {

    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        console.log(params); // {order: "popular"}

        //this.order = params.order;
        //console.log(this.order); // popular

        if (params.search != '' && params.search != undefined ){
          console.log('search');
          console.log(params.search);
         this.msearch = params.search; 
         this.querySearch = true;
        

         this.currentParams = params;
         this.queryParams = '?'+this.queryStr(params);
         this.loadsummary(this.queryParams);
        
        }else{  
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = '?'+this.queryStr(params);
          console.log(this.queryParams);
          console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadsummary(this.queryParams);
        }
      });

    //this.table_load = true
    
  }

  loadsummary(queryParams: any)
  {
    console.log(queryParams);
    this.falset()
    return this.partnerService.Viewsummaryinstallment(queryParams).subscribe((output: any) => {
      this.ListCustomer = output.data;
      this.sumSubs = output.summary;
      //console.log(output);
      this.table_load = false
      this.table_data = true
      this.pagingshow = true
      //this.customerid = this.ViewSTB.data.customer.id;

      this.paging = output.pagex;
      this.page_self = output.pagex.self;
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta;
      this.total_count = this.meta['totalCount'];
      let self = this.page_self['page'];
      if ( self * this.meta['perPage'] < this.meta['totalCount']){
        this.last_index = (self * this.meta['perPage']);
      }else{
        this.last_index = this.meta['totalCount'];
      }
      
      this.first_index = ((self-1)*this.meta['perPage'])+1;
      
    })
  }

  _STB(item: any){
    // console.log(item);
    if (!item.stb ) {
      return '-'
    }else{
      return item.stb
    }
    // this._STBdata = item; 
    // return this._STBdata;
  }

  queryStr(options: any){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }

  search()
  {
    this.querySearch = true;
    this.searchQueryParams = this.queryParams+'&search='+this.msearch;
    this.loadsummary(this.searchQueryParams);
  }

  toggleshow()
  {
    this.isShow = !this.isShow
  }

  filterselect(act:any)
  {
    this.isprint = act

    if(act == 'print' ){
      this.formFilter.get('isprint').setValue('true')
      this.filterexport()
    }else{
      this.formFilter.get('isprint').setValue('')
      this.filterdate()
    }
  }

  filterdate()
  {
    this.falset()
    return this.partnerService.Listallcustfilter(this.formFilter.value).subscribe((output: any) => {
      this.ListCustfilter = output.data;
      
      this.table_load = false
      this.pagingshow = false
      this.table_filter = true
      this.printshow = true
    })
  }

  filterexport()
  {
    return this.partnerService.Listallcustfilter(this.formFilter.value).subscribe((output: any) => {
      this.ListCustexport = output.data;
      this.exportAsXLSX()
    })
  }
  exportAsXLSX():void {
    this.excelService.exportAsExcelFile(this.ListCustexport, 'Report Customer Admin REVA');
  }

  ExportTOExcel() {
    const now = new Date();

    const workBook = XLSX.utils.book_new(); // create a new blank book
    // if(type=='data'){      
      const workSheet = XLSX.utils.json_to_sheet(this.summaryCicilan);  
      
      XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book
      XLSX.writeFile(workBook, 'Data Summary Cicilan - '+now.toLocaleString()+'.xlsx');
    // }
    
    // else if(type=='marketplace'){  
    //   let marketplaceid   = this.formSearch.value.marketplace;   
    //   if(marketplaceid!='all'){        
    //     let marketplacename = this.storeShopList.find(x=>x.id==marketplaceid).name;
      
    //     this.partnerService.GetExportMarketplace('?marketplace='+marketplaceid).subscribe((output: any) => {
    //       //return output;
    //       console.log(output);
    //       this.dataMarketPlace = output;
    //       if(output.status){
    //         const workSheet = XLSX.utils.json_to_sheet(output.data);
    //         XLSX.utils.book_append_sheet(workBook, workSheet, 'Voucher Data'); // add the worksheet to the book
    //         XLSX.writeFile(workBook, marketplacename+' Upload - '+now.toLocaleString()+'.xlsx');
    //       }
    //       else{
    //         this.showAlert(false,output.message);
    //       }
    //     });        
    //   }
    //   else{
    //     this.showAlert(false,'Silahkan Pilih Marketplace di Form Pencarian Terlebih Dahulu.')
    //   }      
    // }   
  }
  
  loadCicilan()
  {
    return this.partnerService.Exportcicilansummary().subscribe((output: any) => {
      console.log(output);
      this.summaryCicilan = output;
      
    })
  }
}

